/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import produce from 'immer';
import {ServiceError} from '@ion/core/src/types/services';
import {AsyncState} from '../../types/redux';
import {
  GLOBAL_SEARCH_ERROR,
  GLOBAL_SEARCH_REQUEST,
  GLOBAL_SEARCH_RESPONSE,
  SET_TOP_SHEET_STATUS
} from '../actions/search';

// defines the shape of this reducers state ...
export interface SearchState extends AsyncState {
  searchTerm: string | null;
  assets: any[] | null;
  drivers: any[] | null;
  geofences: any[]| null;
  error: ServiceError | null,
  topSheet: {
    activeTopSheet: null | string;
    desktopTopSheetOpen: boolean;
    mobileTopSheetOpen: boolean;
  }
}

// defines the initial state for the reducer ...
export const initialState: SearchState = {
  searchTerm : null,
  assets     : null,
  drivers    : null,
  geofences  : null,
  loading    : false,
  error      : null,
  topSheet   : {
    activeTopSheet      : null,
    desktopTopSheetOpen : true,
    mobileTopSheetOpen  : false
  }
};

// defines the reducers ...
const reducers = {
  [GLOBAL_SEARCH_REQUEST] : (draft: SearchState, {searchTerm}) => {
    draft.searchTerm = searchTerm;
    draft.loading    = true;
  },
  [GLOBAL_SEARCH_RESPONSE] : (draft: SearchState, {assets, drivers, geofences}) => {
    draft.assets    = assets;
    draft.drivers   = drivers;
    draft.geofences = geofences;
    draft.loading   = false;
  },
  [GLOBAL_SEARCH_ERROR] : (draft: SearchState, {error}) => {
    draft.assets  = error;
    draft.loading = false;
  },
  [SET_TOP_SHEET_STATUS] : (draft: SearchState, {data}) => {
    draft.topSheet = {...draft.topSheet, ...data};
  }
};

// defines all reducers for actions of interest to the this reducer ...
export default produce((draft: SearchState = initialState, action) => {
  reducers?.[action.type]?.(draft, action);
  return draft;
});
